'user strict';

import Hashids from 'hashids';
import { createSelector } from 'reselect';

import { getPageJobId, getUrlParams } from '../app/selectors';
import { getUsersMap } from '../users/selectors';
import { getMap as getLocationsMap } from '../locations/selectors';

export const getProps = (_, props) => props;
export const getJobId = (_, { jobId }) => jobId;
export const companyId = (_, { companyId }) => companyId;

export const getOrdersMap = ({ orders }) => orders.byId;

export const getJobById = ({ orders }) => id => orders.byId[ id ];

export const getPageJob = createSelector(
	[ getUrlParams, getOrdersMap ],
	({ companyId, jobId }, jobs) => Object.entries(jobs).reduce(
		(j, [ _id, job ]) => {
			if (!j) {
				if (job.id === jobId && job.companyId === parseInt(companyId)) {
					return job;
				}
			}
			return j;
		},
		null
	)
);

export const getPageJobLocation = createSelector(
	[ getUrlParams, getPageJob, getLocationsMap ],
	({ hashLocationId }, job, locations) => {

		if (job) {
			const hashids = new Hashids();
			const locationId = hashids.decodeHex(hashLocationId);

			return job.locations.find(l => l.locationId === locationId);
		}
	}
);

export const getPropJobs = createSelector(
	[ getProps, getOrdersMap ],
	({ jobIds }, jobs) => jobIds.map(_id => jobs[ _id ])
);

export const getJob = createSelector(
	[ getOrdersMap, getJobId ],
	(jobs, jobId) => jobs[ jobId ]
);

export const getOrder = createSelector(
	[ getOrdersMap, getPageJobId ],
	(ordersMap, id) => ordersMap[ id ]
);

export const makeGetOrder = () => createSelector(
	[ getOrdersMap, getPageJobId ],
	(ordersMap, id) => ordersMap[ id ]
);

export const getAssignedIds = createSelector(
	[
		getUsersMap,
		getUrlParams,
	],
	(users, { username, date }) => {

		const user = users[ username ];

		if (!user) {
			return undefined;
		}

		const { assigned } = user;
		const { jobs } =  assigned[ date ];

		return jobs.map(j => j._id);
	}
);

const getAssigned = createSelector(
	[
		getUsersMap,
		getUrlParams,
	],
	(users, { username, date }) => {

		const user = users[ username ];

		if (!user) {
			return undefined;
		}

		const { assigned } = user;

		if (date in assigned) {
			const { jobs } =  assigned[ date ];

			return jobs;
		}
	}
);

export const makeGetNextOrderId = () => createSelector(
	[ getAssignedIds, getPageJobId ],
	(assignedIds, id) => {

		if (Array.isArray(assignedIds)) {
			const idx = assignedIds.indexOf(id);

			if (idx < assignedIds.length - 1) {
				return assignedIds[idx + 1];
			}
		}
	}
);

export const makeGetPreviousOrderId = () => createSelector(
	[ getAssignedIds, getPageJobId ],
	(assignedIds, id) => {

		if (Array.isArray(assignedIds)) {
			const idx = assignedIds.indexOf(id);

			if (idx > 0) {
				return assignedIds[idx - 1];
			}
		}
	}
);
